import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/private/HomeView.vue'
import auth from '../middleware/auth';

const routes = [
    {
        path: '/',
        name: 'home',

        component: HomeView,
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate',
            title: 'Dashboard',
        },
    },
    {
        path: '/benchmark',
        name: 'benchmark',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/BenchmarkView.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate',
            title: 'Benchmark',
        },
    },
    {
        path: '/benchmark/view/:id',
        name: 'benchmarkView',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/BenchmarkViewPrint.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrint',
            title: 'Benchmark',
        },
    },
    {
        path: '/progress',
        name: 'progress',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/ProgressView.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate',
            title: 'Avances'
        },
    },
    {
        path: '/progress/view',
        name: 'progress.view',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/ProgressViewPrint.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrint',
            title: 'Preguntas y Respuestas'
        },
    },
    {
        path: '/dimension/:id',
        name: 'dimension2',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/DimensionViewDynamic.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivateVertical',
            title: 'Dimension'
        },
    },
    {
        path: '/dimension/:id/:period',
        name: 'dimensionPeriod',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/DimensionViewDynamic.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivateVertical',
            title: 'Dimension'
        },
    },
    {
        path: '/admin',
        name: 'admin',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/DashboardAdminView'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate',
            title: 'Dashboard Admin'
        },
    },
    {
        path: '/admin/dimensions',
        name: 'admin-dimensions',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/Dimension/Index'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate',
            title: 'Editor de dimensiones'
        },
    },
    {
        path: '/admin/dimensions/:id',
        component: () => import(/* webpackChunkName: "about" */ '../views/private/Dimension/Questions'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate',
            title: 'Editor de dimension'
        },
    },
    {
        path: '/admin/dimensions/:id/:question',
        component: () => import(/* webpackChunkName: "about" */ '../views/private/Dimension/Options'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate'
        },
    },
    {
        path: '/admin/users',
        name: 'adminUsers',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/UserAdmin/Index.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate'
        },
    },
    {
        path: '/admin/users/:id',
        name: 'adminUser',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/UserAdmin/Edit.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate'
        },
    },
    {
        path: '/profile',
        name: 'profile',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/ProfileView.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate'
        },
    },
    {
        path: '/users',
        name: 'users',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/UserIndex.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate'
        },
    },
    {
        path: '/user/:id',
        name: 'users-view',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/UserView.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate'
        },
    },
    {
        path: '/companies',
        name: 'companies',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/Company/Index.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate'
        },
    },
    {
        path: '/company/:id',
        name: 'companyOption',
        component: () => import(/* webpackChunkName: "about" */ '../views/private/Company/Update.vue'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate'
        },
    },
    {
        path: '/admin/periods',
        name: 'admin-periods',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/private/Period/Index'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate',
            title: 'Editor de Periodos'
        },
    },
    {
        path: '/admin/periods/:id',
        name: 'admin-periods-view',
        component: () => import(/* webpackChunkName: "about" */ '../views/private/Period/Edit'),
        meta: {
            middleware: [auth],
            layout: 'AppLayoutPrivate',
            title: 'Editor de Periodo'
        },
    },
    {
        path: '/auth/login',
        name: 'login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/auth/LoginView.vue'),
        meta: {
            layout: 'AppLayoutAuth' // name of the layout
        },
    },
    {
        path: '/auth/register',
        name: 'register',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/auth/RegisterView.vue'),
        meta: {
            layout: 'AppLayoutAuth' // name of the layout
        },
    },
    {
        path: '/auth/register/successful',
        name: 'register-successful',
        component: () => import(/* webpackChunkName: "about" */ '../views/auth/RegisterOkView.vue'),
        meta: {
            layout: 'AppLayoutAuth' // name of the layout
        },
        props: true
    },
    {
        path: '/auth/forgot-password',
        name: 'forgot-password',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/auth/ForgotPasswordView.vue'),
        meta: {
            layout: 'AppLayoutAuth' // name of the layout
        },
    },
    {
        path: '/auth/forgot-password/confirm',
        name: 'forgot-password-confirm',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/auth/ForgotPasswordConfirmView.vue'),
        meta: {
            layout: 'AppLayoutAuth' // name of the layout
        },
    },
    {
        path: '/auth/verify-email',
        name: 'verify-email',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/auth/VerifyEmailView.vue'),
        meta: {
            layout: 'AppLayoutAuth' // name of the layout
        },
    },
    {
        path: '/:pathMatch(.*)*', name: 'not-found',
        meta: {
            layout: 'AppLayoutError' // name of the layout
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/NotFoundView.vue')
    }
]


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    console.log(to.meta);
    if(to.meta.title !== undefined){
        document.title ='iDES SOFOFA | '+to.meta.title;
    } else {
        document.title = 'iDES SOFOFA';
    }

    next()
})

router.resolve({
    name: 'not-found',
    params: {pathMatch: ['not', 'found']},
}).href

export default router
